const getOptOutStatus = state => state?.optoutStatus

const selectors = {
  getOptOutStatus,
}

export default selectors
